import mitt from 'mitt';

// Create a mitt instance
const emitter = mitt();

// Create a backwards-compatible Bus object that supports both Nuxt 2 and Nuxt 3 patterns
export const Bus = {
  ...emitter,
  // Add Vue 2 style methods as aliases
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
};
